import script from "./ArticlesListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesListView.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlesListView.css?vue&type=style&index=0&id=eeba507c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeba507c"]])

export default __exports__